export const parseCamelCaseToLabel = (key: string): string =>
  key[0].toUpperCase() +
  key.slice(1)
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .trim();